<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="合约创建"
      :visible.sync="visible"
      width="600px"
      center
    >
      <div class="">
        <!-- <div class="close" @click="$emit('update:visible', false)">×</div> -->

        <div class="text">预计合约地址</div>
        <div class="flex-row">
          <div class="address">{{ contractData.contractAddr }}</div>
          <div
            class="copyAddress"
            @click="copyText($event, contractData.contractAddr)"
          >
            复制
          </div>
        </div>

        <div class="flex-col">
          <div class="text">开源参数</div>
          <div>
            <span class="parameter">Optimization: ves</span>
            <span class="parameter">Runs: 200</span>
          </div>
          <div>
            <div>
              <span class="parameter">Solidity Version: 0.8.18</span>
              <span class="parameter">License: MIT</span>
            </div>
          </div>
          <div style="margin-top: 30px">
            <span class="copy" @click="copyText($event, contractData.content)"
              >复制源码</span
            >
          </div>
        </div>
        <div class="bottom">
          <div class="createBtn" v-if="finishDeployed" @click="goDetail()">
            查看合约详情
          </div>
          <el-button class="createBtn2" v-else @click="deployClick()"
            >发布合约</el-button
          >
        </div>
      </div>
    </el-dialog>
    <LoadingAlert
      :visible.sync="showLoading"
      :LoadingText="loadingText"
    ></LoadingAlert>
  </div>
</template>
<script>
import { ethers } from "ethers";
import Clipboard from "clipboard";
import { deployContract } from "@/config/wallet.js";
import { contractVerify } from "@/config/api.js";
import LoadingAlert from "@/components/alert/loading";
export default {
  name: "deployAlert",
  components: {
    LoadingAlert,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    contractData: {
      type: Object,
      default: {},
    },
    deployData: {
      type: Array,
      default: [],
    },
    tokenForm: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      finishDeployed: false,
      account: localStorage.getItem("TokenBox-account"),
      showLoading: false,
      loadingText: "正在请求部署合约",
    };
  },
  mounted() {
    console.log("contractData=", this.contractData);
  },
  methods: {
    async deployClick() {
      //  var s = (ethers.utils.parseUnits(
      //     "10000",
      //     this.tokenForm.decimals
      //   )).toString();
      //   console.log("test===",ethers.utils.parseUnits(
      //     "10000",
      //     this.tokenForm.decimals
      //   ));
      //   return
      this.showLoading = true;
      console.log("开始发布合约=", this.deployData);
      //发布合约 发行量需要根据精度转成对应bignumber
      var temp = JSON.parse(JSON.stringify(this.deployData[2]));
      temp[1] = ethers.utils
        .parseUnits(this.tokenForm.total.toString(), this.tokenForm.decimals)
        .toString();
      if (this.tokenForm.template=="freeMint") {
        temp[2] = ethers.utils
          .parseUnits(temp[2].toString(), this.tokenForm.decimals)
          .toString();
      }
      var res = await deployContract(
        this.contractData.abi,
        this.contractData.bin,
        this.deployData[0],
        this.deployData[1],
        temp,
        this.deployData[3]
      );

      if (res && res.address) {
        this.contractData.contractAddr = res.address;
        this.loadingText = "合约已提交，等待区块确认";
        await res.deployed();
        console.log("deployContract=", res.address);
        this.finishDeployed = true;

        this.$message({
          message: "合约发布成功",
          type: "success",
        });
        //合约开源
        var postData = {
          contractaddress: this.contractData.contractAddr,
          name: this.tokenForm.name,
          symbol: this.tokenForm.symbol,
          constructorArguements: [
            this.deployData[0],
            this.deployData[1],
            temp,
            this.deployData[3],
          ],
          contractCode: this.contractData.contractCode,
          owner: this.account,
          chainId: localStorage.getItem("TokenBox-chainID"),
          argument: {
            name: this.tokenForm.name,
            website: this.tokenForm.website,
            telegram: this.tokenForm.telegram,
            twitter: this.tokenForm.twitter,
            discord: this.tokenForm.discord,
            description: this.tokenForm.introduction,
          },
        };
        console.log("开源提交参数：", postData);
        contractVerify(JSON.stringify(postData));
      } else {
        if (res && res.message) {
          this.$showErrorMessage(res);
        }
      }
      this.showLoading = false;
    },
    goDetail() {
      this.$router.push({
        path: "/contractDetail",
        query: {
          contractId: this.contractData.contractId,
          mode: this.contractData.contractCode,
        },
      });
    },
    copyText(e, text) {
      const clipboard = new Clipboard(e.target, {
        text() {
          return text;
        },
      });

      clipboard.on("success", () => {
        this.$message.success("复制成功！");
        clipboard.destroy();
      });

      clipboard.on("error", (e) => {
        console.log("该浏览器不支持自动复制!", "warning", e);
        clipboard.destroy();
      });

      clipboard.onClick(e);
    },
  },
};
</script>
<style lang="scss" scoped>
.deploy-body {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: 0.5);
  padding: 7% 20%;

  .close {
    font-size: 30px;
    border: #000 solid 1px;
    width: 30px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    border-radius: 20px;
    float: right;
    margin: -30px -50px 0 0;
  }
}
.title {
  font-weight: normal;
  font-size: 20px;
  color: #000;
  line-height: 23px;
  text-align: center;
  font-style: normal;
  text-transform: none;
  margin: 30px 0 50px 0;
}
.text {
  margin: 20px 0 10px 0;
}
.address {
  width: 85%;
  padding: 0 10px;
  line-height: 45px;
  height: 45px;
  background: #e9e6e6;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #999797;
}
.copyAddress {
  color: #7d77c0;
  line-height: 45px;
  height: 45px;
  margin-left: 15px;
  cursor: pointer;
}
.copy {
  color: #ffffff;
  //background: rgb(189, 170, 204);
  background: #4339b6;
  border-radius: 4px;
  border: 1px solid #aba4ff;
  padding: 10px 20px;
  line-height: 60px;
  margin-right: 20px;
  white-space: nowrap;
  cursor: pointer;
}
.parameter {
  background: #918cd4;
  border-radius: 4px;
  border: 1px solid #7d77c0;
  padding: 10px 20px;
  line-height: 60px;
  margin-right: 20px;
  white-space: nowrap;
  color: #ffffff;
}

.createBtn {
  width: 228px;
  height: 46px;
  background: #4438d4;
  border-radius: 30px 30px 30px 30px;
  border: 1px solid #695cff;

  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  line-height: 46px;
  text-align: center;
  font-style: normal;
  text-transform: none;

  margin: 100px auto 0 auto;
  cursor: pointer;
}

.createBtn2 {
  width: 228px;
  height: 46px;
  background: #4438d4;
  border-radius: 30px 30px 30px 30px;
  border: 1px solid #695cff;

  font-weight: normal;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  font-style: normal;
  text-transform: none;

  display: flex;
  justify-content: center;
  align-items: center;

  margin: 50px auto 0 auto;
  cursor: pointer;
}
/deep/ .el-dialog--center {
  border-radius: 20px;
}
</style>